<div
  sondermindMediaQueryAttribute
  *ngIf="component.config.helpText && !(overrideReasonDetail$ | async) && !(overrideDesiredAvailability$ | async)"
  class="help-text"
  [ngClass]="component.config.styleClasses"
  [innerHTML]="$any(component.config.helpText) | bindTemplate:response.data"
  data-test="help-text"
>
</div>
<!-- TODO: Remove in in MER-2127 -->
<div
  sondermindMediaQueryAttribute
  *ngIf="component.config.helpText && (overrideReasonDetail$ | async)"
  class="help-text"
  [ngClass]="component.config.styleClasses"
  data-test="help-text"
>
  This could include things like:
  <ul class="help-text-list">
    <li>
      additional therapy specialties you're looking for
    </li>
    <li>
      race/ethnicity, age, sexuality, or some other aspect of the therapist's identity
    </li>
  </ul>
</div>
